<template>
  <div>
    <el-button
      type="primary"
      style="margin-bottom:10px"
      :disabled="!this.multipleSelection.length"
      @click="applayOpen"
    >
      开票申请
    </el-button>

    <el-table
      ref="billTable"
      :data="tableData"
      border
      style="width: 100%"
      sum-text="合计"
      show-summary
      :summary-method="handleTotal"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        :selectable="handleSelectEnable"
      />
      <el-table-column type="index" label="序号" width="50" align="left" fixed="left" />
      <el-table-column prop="orderNum" label="订单编号" width="100" align="left" fixed="left" />
      <el-table-column prop="productCode" label="销售产品代码" width="100" align="left" />
      <el-table-column prop="salesInvoiceName" label="商品名称" width="200" align="left" />
      <el-table-column prop="productName" label="规格型号" width="120" align="left" />
      <el-table-column prop="productNum" label="数量" align="left" />
      <el-table-column prop="unit" label="单位" align="left" />
      <el-table-column prop="productPriceSingle" label="单价" align="right" header-align="left" />
      <el-table-column prop="orderAmount" label="订单金额" align="right" header-align="left" />
      <el-table-column prop="beforeSplitProductPriceSingle" label="拆分前单价" width="100" align="right" header-align="left" />
      <el-table-column prop="settlementUnitPrice" label="实际结算单价" width="100" align="right" header-align="left" />
      <el-table-column prop="settlementAmount" label="实际结算金额" width="100" align="right" header-align="left" />
      <el-table-column prop="expectedDeliveryDate" label="期望发货日期" width="100" align="left" />
      <el-table-column prop="quantityShipped" label="已发货数量" width="100" align="left" />
      <el-table-column prop="quantityNotShipped" label="未发货数量" width="100" align="left" />
      <el-table-column prop="taxName" label="税收分类名称" width="100" align="left" />
      <el-table-column prop="taxRate" label="税率" align="right" header-align="left">
        <template v-slot="{row}">
          <span>{{ row.taxRate ? `${row.taxRate}%` : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="kpFlag" label="是否可提前开票" width="120" align="left">
        <template v-slot="{row}">
          <span>{{ row.kpFlag ? '是' : '否' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 提交 -->
    <base-info
      ref="baseInfoRef"
      :from-info="detailInfo"
      @chang-client="changClient"
      @handle-submit="handleSubmit"
      @handle-cancel="closeDialog"
      @handle-remove="handleRemove"
    />
  </div>
</template>

<script>
// 编辑
import baseInfo from '@/components/baseInfoSubmit';
import { MathAdd } from '@/libs/util';
import { getUnInvoiceProducts, applyAdvanceInvoice, submitApply } from '@/API';
export default {
  components: {
    baseInfo
  },

  props: {
    // 基本信息
    infoData: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      multipleSelection: [],
      tableData: [],
      isShow: false,
      bankInfo: {},
      invoiceData: {},
      detailInfo: {} // 开票通知单信息
    };
  },

  watch: {
    infoData: {
      handler () {
        this.initData();
      },
      deep: true
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    // 主页面Table
    initData () {
      if (!(this.infoData && this.infoData.contractNum)) return;
      getUnInvoiceProducts(this.infoData.contractNum).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.invoiceData = data;
          this.tableData = data.productList || [];
          this.bankInfo = data.bankInfo || [];
        }
      });
    },

    // 客户名称变动 字段变更
    changClient (val = '', list = []) {
      const item = list.find(i => i.kpOrderUnit === val);
      this.detailInfo = {
        ...this.detailInfo,
        kpOrderUnitTemp: val,
        bankInfo: {
          ...this.detailInfo.bankInfo,
          kpOrderUnitCode: item && item.kpOrderUnitCode,
          kpTaxpayerNum: item && item.kpTaxpayerNum,
          taxRegistrationAddress: item && item.taxRegistrationAddress,
          taxRegistrationTelephone: item && item.taxRegistrationTelephone,
          bankDeposit: item && item.bankDeposit,
          bankAccount: item && item.bankAccount
        }
      };
    },

    // 合计
    handleTotal (params) {
      const { columns } = params;
      const tempTotal = ['合计'];
      columns.forEach((item, index) => {
        if (item.property === 'productNum') { // 数量
          tempTotal[index] = this.allAmount('productNum');
        } else if (item.property === 'orderAmount') { // 订单金额
          tempTotal[index] = this.allAmount('orderAmount');
        } else if (item.property === 'settlementAmount') { // 实际结算金额
          tempTotal[index] = this.allAmount('settlementAmount');
        } else if (item.property === 'quantityShipped') { // 已发货数量
          tempTotal[index] = this.allAmount('quantityShipped');
        } else if (item.property === 'quantityNotShipped') { // 已发货数量
          tempTotal[index] = this.allAmount('quantityNotShipped');
        }
      });
      return tempTotal;
    },

    allAmount (type) {
      let cont = 0;
      (this.tableData || []).forEach((item) => {
        cont = MathAdd(cont, item[type]);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    // 禁用表格多选框
    handleSelectEnable (row) {
      if (!row.kpFlag) {
        return false;
      } else {
        return true;// 不禁用
      }
    },

    handleIsNumconsistent () { // 处理订单编号是否一致
      if (!this.multipleSelection.length) return false;
      const status = this.multipleSelection.every(item => this.multipleSelection[0].orderNum === item.orderNum);
      if (status) return true;
      if (!status) {
        this.$message.error('提前开票的产品税率或订单号不一致');
        this.closeDialog();
        return false;
      }
    },

    applayOpen () { // 申请开票
      if (!this.handleIsNumconsistent()) return;
      const params = {
        bankInfo: this.bankInfo,
        contractNum: this.infoData.contractNum,
        orderNum: this.multipleSelection[0].orderNum, // 订单编号
        projectName: this.infoData.projectName,
        orderUnitCode: this.infoData.orderUnitCode,
        orderUnit: this.infoData.orderUnit,
        supplyUnit: this.infoData.supplyUnit,
        contractType: this.infoData.contractType,
        productList: this.multipleSelection || [],
        currencyName: this.infoData.currencyName,
        revMethod: this.invoiceData.revMethod,
        revRule: this.invoiceData.revRule,
        customerType: this.invoiceData.customerType
      };
      console.log(params, 'params');
      applyAdvanceInvoice(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.$refs.baseInfoRef.openDialog();
          this.detailInfo = data || {};
          this.detailInfo.kpOrderUnitTemp = this.detailInfo.bankInfo.kpOrderUnit;
          this.detailInfo.isAllInvoice = false;
          if (this.detailInfo.fileName && (Number(this.detailInfo.fileName) !== 0)) {
            this.detailInfo.fileListTemp = [{
              name: this.detailInfo.fileName,
              fileToken: this.detailInfo.fileToken
            }];
          }
        } else {
          this.isShow = false;
          this.$refs.billTable.clearSelection();
        }
      }).catch(e => {
        console.log(e);
        this.$refs.billTable.clearSelection();
      });
    },

    // 取消申请
    closeDialog () {
      this.detailInfo = {};
      this.multipleSelection = [];
      this.$refs.billTable.clearSelection();
    },

    // 删除文件
    handleRemove () {
      this.detailInfo.fileListTemp.splice(0);
    },

    handleSubmit () { // 提交
      const { fileListTemp, invoiceMark, invoiceType, invoiceEmail, invoiceAmount } = this.detailInfo;
      const { receiveUser, receiveTelephone, receiveCompany, receiveAddress } = this.detailInfo.bankInfo;
      if (!invoiceType) {
        this.$message.error('金税发票类型必填');
        return;
      }
      if (!invoiceMark) {
        this.$message.error('发票标记必填');
        return;
      }
      if (!invoiceAmount) {
        this.$message.error('开票总金额必填');
        return;
      }
      if (!(receiveUser && receiveTelephone && receiveCompany && receiveAddress)) {
        this.$message.error('请输入必填项');
        return;
      }
      if (invoiceType === 2 && !(invoiceEmail && invoiceEmail.length)) {
        this.$message.error('金税发票类型选择的是“增值税电子普通发票”时，发票接收邮箱必填');
        return;
      }
      const temp = this.detailInfo.productList.map(item => {
        return {
          ...item,
          id: null
        };
      });
      this.detailInfo.productList = temp;
      const params = {
        ...this.detailInfo,
        fileToken: fileListTemp && fileListTemp.length && fileListTemp[0].fileToken,
        fileName: fileListTemp && fileListTemp.length && fileListTemp[0].name,
        bankInfo: {
          ...this.detailInfo.bankInfo,
          kpOrderUnit: this.detailInfo.kpOrderUnitTemp
        }
      };
      submitApply(params).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.initData();
          this.$message.success('提交成功');
          this.$refs.baseInfoRef.handleCancel();
        }
      }).catch(e => {
        console.log(e);
      });
    }
  }
};
</script>
